import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface User {
  id: string
  username: string
  email: string
  full_name: string | null
  role: 'learner' | 'instructor' | 'admin'
  avatar_url: string | null
  email_verified: boolean
}

interface AuthState {
  accessToken: string | null
  refreshToken: string | null
  user: User | null
  mustChangePassword: boolean
  setTokens: (access: string, refresh: string) => void
  setUser: (user: User) => void
  setMustChangePassword: (v: boolean) => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      mustChangePassword: false,
      setTokens: (access, refresh) => set({ accessToken: access, refreshToken: refresh }),
      setUser: (user) => set({ user }),
      setMustChangePassword: (v) => set({ mustChangePassword: v }),
      logout: () => set({ accessToken: null, refreshToken: null, user: null, mustChangePassword: false }),
    }),
    { name: 'hicain-auth' },
  ),
)
